import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import ContentWrapper from '../Layout/ContentWrapper';

const styles = {
  marginLeft: '10%',
  marginRight: '10%',
  padding: '30px',
  textAlign: 'center',
  fontSize: '25px',
};

const buttonWrapperStyle = {
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
}

const Modal = ({ content, onConfirm, onCancel }) => (
  <ContentWrapper>
    <Row>
      <Col xs={12} style={{ padding: '20px' }}>
        <div style={styles}>
          {
            content
          }
        </div>
      </Col>
    </Row>
    <Row>
      <Col xs={6} style={buttonWrapperStyle}>
        <button
          className="btn btn-primary col-sm-6 buttonStyle"
          onClick={onCancel}
        >
          <Translate value="edit" />
        </button>
      </Col>
      <Col xs={6} style={buttonWrapperStyle}>
        <button
          className="btn btn-primary col-sm-6 buttonStyle"
          onClick={onConfirm}
        >
          <Translate value="confirmNcontinue" />
        </button>
      </Col>
    </Row>
  </ContentWrapper>);

const ConfirmModal = ({
 title, content, onConfirm, onCancel, isVisible
}) => (
    <SkyLightStateless
      dialogStyles={{ height: '350px' }}
      isVisible={isVisible}
      onCloseClicked={onCancel}
      title={title}
    >
      <Modal
        content={content}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </SkyLightStateless>);

export default ConfirmModal;



// WEBPACK FOOTER //
// ./master/jsx/components/common/confirmModal.jsx